export const novemberAbbreviatedLowercase = "aqa";
export default {novemberAbbreviatedLowercase};